<figure class="aid-cost-illustration" [attr.aria-labelledby]="titleId" [attr.aria-describedby]="descId">
  <h2 [id]="titleId" class="aid-cost-illustration__title">{{ title }}</h2>
  <p [id]="descId" class="visually-hidden">{{ description }}</p>
  <!-- Visual-only graphic; title + description convey meaning -->
  <svg class="aid-cost-illustration__svg" viewBox="0 0 280 220" aria-hidden="true" focusable="false">
    <!-- Total cost brace (left) -->
    <path
      class="aid-cost-illustration__brace"
      d="M 36 16 H 24 V 204 H 36"
      fill="none"
      stroke="#5f6368"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <text
      class="aid-cost-illustration__brace-label"
      x="10"
      y="110"
      transform="rotate(-90 10 110)"
      text-anchor="middle"
    >Total cost</text>

    <defs>
      <clipPath [attr.id]="barClipId">
        <rect x="48" y="16" width="56" height="188" rx="8" ry="8" />
      </clipPath>
    </defs>
    <g [attr.clip-path]="'url(#' + barClipId + ')'">
      <!-- Net price (top ~38%) -->
      <rect x="48" y="16" width="56" height="72" class="aid-cost-illustration__bar-net" />
      <!-- Grants (bottom ~62%) -->
      <rect x="48" y="88" width="56" height="116" class="aid-cost-illustration__bar-grants" />
    </g>
    <rect
      x="48"
      y="16"
      width="56"
      height="188"
      rx="8"
      ry="8"
      fill="none"
      stroke="#c5d0de"
      stroke-width="1"
    />

    <!-- Net price callout -->
    <path d="M 104 52 H 118" fill="none" stroke="#0066cc" stroke-width="1.75" />
    <circle cx="124" cy="52" r="3.5" fill="#0066cc" />
    <text class="aid-cost-illustration__label aid-cost-illustration__label--net" x="134" y="48">
      Your estimated
    </text>
    <text class="aid-cost-illustration__label aid-cost-illustration__label--net" x="134" y="66">
      net price
    </text>

    <!-- Grants callout -->
    <path d="M 104 146 H 118" fill="none" stroke="#137333" stroke-width="1.75" />
    <circle cx="124" cy="146" r="3.5" fill="#137333" />
    <text class="aid-cost-illustration__label aid-cost-illustration__label--grants" x="134" y="142">
      Grants &amp;
    </text>
    <text class="aid-cost-illustration__label aid-cost-illustration__label--grants" x="134" y="160">
      scholarships
    </text>
  </svg>
</figure>
